<template>
  <img
    style="max-width: 400px; height: auto"
    :src="image"
    alt=""
    @load="onLoaded"
  >
  <div v-if="!loaded">
    <PulseLoader />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { PulseLoader } from 'vue-spinner';

const loaded = ref(false);
const { image = '' } = defineProps({image: String});

function onLoaded() {
  loaded.value = true;
}
</script>

<style scoped>

</style>
